import React from 'react';
import { Link } from 'react-router-dom';
import './Goodbye.css';

function Goodbye() {
  return (
    <div className="goodbye-container">
      <div className="goodbye-card">
        <div className="goodbye-icon">👋</div>
        <h1>Account Deleted</h1>
        <p>Your account has been successfully deleted.</p>
        <p className="goodbye-subtext">
          We're sorry to see you go. If you ever want to come back, 
          you're always welcome to create a new account.
        </p>
        <div className="goodbye-actions">
          <Link to="/" className="goodbye-btn-primary">
            Return to Home
          </Link>
          <Link to="/contact" className="goodbye-btn-secondary">
            Give us Feedback
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Goodbye;
